// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_i3-3";
export var flatBottomCorners = "_i3-5";
export var productImage = "_i3-0";
export var quantityContainer = "_i3-2";
export var quantityHeader = "_i3-6";
export var tooltip = "_i3-1";
export var wrapAndEllipsesOverflow = "_i3-4";